<template>
  <div class="container">
    <router-view />
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations(["changeCurrentCategory", "setUrls"])
  },
  mounted: function() {
    this.changeCurrentCategory("");
    this.setUrls({
      topicsUrl: "/topics/",
      tagsUrl: "/tags/"
    });
  }
};
</script>
